export const Projects = [
    {
        id: 1,
        name: "Apple landing page",
        tags: ["figma"],
        description:"This is an Apple landing page meticulously crafted in Figma, offering a sleek and immersive gateway to Apple's world of cutting-edge products and services.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1D7qt8ZDiEAjfSfblTXZwTDTSR26dOmT8",
        link: "https://www.figma.com/proto/6mzE2MymkJfPB2Nlx2UW2t/Apple-Watch-Store-Landing-Page-Design?page-id=0%3A1&type=design&node-id=102-102&viewport=52%2C494%2C0.14&t=TsH3zXh3wJIDbZ1x-1&scaling=scale-down&starting-point-node-id=102%3A102&mode=design"
    },
    {
        id: 2,
        name: "Social media app ",
        tags: ["figma"],
        description:"This Figma-designed social media app offers a seamless experience, allowing users to effortlessly access notifications, engage in chats, and apply filters for personalized content in one intuitive platform.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1QZSVkYrj7hXfsQgj7Q3cI4eJ4m2IegrF",
        link: "https://www.figma.com/proto/WrITDjjYp2cuMGmsB6CgeV/Social-media?page-id=0%3A1&type=design&node-id=103-573&viewport=122%2C82%2C0.13&t=nAUf2tTBbBeQiwa4-1&scaling=contain&starting-point-node-id=103%3A573&mode=design"
    },
    {
        id: 3,
        name: "Movie booking app ",
        tags: ["figma"],
        description:"Experience the convenience of movie booking at your fingertips with this Figma-designed app. Seamlessly select, book, and enjoy your favorite films with a user-friendly interface.",
        imgSrc: "https://drive.google.com/uc?export=view&id=15Ny4F-w6-R7Qhh9hrA7cCyqpNJInp_QT",
        link: "https://www.figma.com/proto/8PozSURitxyTouU5A5h2Vl/Movie-bookig-app?page-id=0%3A1&type=design&node-id=102-74&viewport=-281%2C-422%2C0.67&t=fuMlsfkHym3gSnPO-1&scaling=scale-down&starting-point-node-id=102%3A74&mode=design"
    },
    {
        id: 4,
        name: "Toggle switch ",
        tags: ["figma"],
        description:"This Figma-crafted toggle switch combines form and function, allowing users to effortlessly control settings with its sleek and intuitive design. A stylish way to toggle between options and enhance user interactions.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1ZlbtWFJkWUx4ynYGnifnmmu6dUnVpPhT",
        link: "https://www.figma.com/proto/Y5ApYx7qBUZ1rXeRKI94Si/Toggle-switch?page-id=302%3A2&node-id=304-1555&mode=design&t=EUJ1D1P1lZEp79rV-1"
    },
    {
        id: 5,
        name: "E-commerce app ",
        tags: ["adobe xd"],
        description:"This Figma-designed pen e-commerce app for headphones provides a stylish and user-friendly platform to explore, select, and purchase high-quality audio gear. Elevate your shopping experience with a sleek pen-themed interface.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1GMIN0DJhxyXzsFWF9WUpxynHcdNTJRU8",
        link: "https://xd.adobe.com/view/77cb715f-7d22-465d-8636-4e07da521199-2298/"
    },
    {
        id: 6,
        name: "Pen parralax landing page ",
        tags: ["adobe xd"],
        description:"This Figma-created parallax landing page is a captivating digital canvas, using pen-inspired animations to engage and guide visitors through an immersive storytelling experience. Experience the art of scrolling with a dynamic, pen-themed design.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1-4jfxSx2xc4fME5ucDpepFCBujHFtYkv",
        link: "https://xd.adobe.com/view/21521990-2ee2-478d-8456-f27a9ff42020-7401/"
    },
    {
        id: 7,
        name: "Random avatar generator ",
        tags: ["react","html","css","js"],
        description:"In this avatar generator, we have several buttons for different categories to choose from, the next button to generate random images, and a download button to finally download your favorite avatar.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1qstESisNXnlo8NpuyFxz_VtGYEctRIqB",
        link: "https://avatargen-iu4w-hima.vercel.app/"
    },
    {
        id: 8,
        name: "Cancer blog ",
        tags: ["html","css","js","sass"],
        description:"This is a blog website of Cancer Blog using Javascript, HTML/CSS. In this it show types, treatment of cancer with stories of cancer warriors.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1mUYy8RLD0OtG_Hczm7FFEZkxn8ODdhrs",
        link: "https://cancerblog-hj.vercel.app/"
    },
    {
        id: 9,
        name: "Random quote generator ",
        tags: ["html","css","js"],
        description:"The webpage displays a random quote from a collection and upon the click of a button, it randomly generates a new quote.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1e8MOz7RHjLlwcD862JXIu3-EL3LySbIV",
        link: "https://quote-generator-himanshijainn.vercel.app/"
    },
    {
        id: 10,
        name: "Covid-19 Tracker ",
        tags: ["react","html","css","js"],
        description:"COVID-19 Tracker is a ReactJS web app using real-time API to display current COVID-19 statistics by country.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1yB0i24Z8lPDiTOpk_zWrl1NImlxMK-pe",
        link: "https://covid19tracker-hj.vercel.app/"
    },
    {
        id: 11,
        name: "Gallery ",
        tags: ["html","css","js"],
        description:"The 360-Degree Rotating Gallery is an immersive image gallery that uses HTML, CSS, and JavaScript to allow users to explore a collection of images from all angles",
        imgSrc: "https://drive.google.com/uc?export=view&id=1seZ9YNxg56XXdB05pWMe2uWGYqtAvqd6",
        link: "https://gallery-git-main-himanshijainn.vercel.app/" 
    },
    {
        id: 12,
        name: "Music player ",
        tags: ["html","css","js"],
        description:"Introducing 'Feel the Love' music player: sleek design, easy controls. Play, pause, enjoy!",
        imgSrc: "https://drive.google.com/uc?export=view&id=1anOTXFbg_B415nhBnTteBaSJAdAGSuUp",
        link: "https://musicplayer-himanshijainn.vercel.app/"
    },
    {
        id: 13,
        name: "Clock ",
        tags: ["html","css","js"],
        description:"Analog and digital clocks combined into a single display, created using HTML, CSS, and JavaScript, providing both visual and numerical time representations.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1IfZ5zGvNulhWJvPGi5OMNIL5lMMpjX4N",
        link: "https://clock-git-main-himanshijainn.vercel.app/"
    },
    {
        id: 14,
        name: "Info card ",
        tags: ["html","css","js"],
        description:"Discover my world through this dynamic info card. It elegantly presents a glimpse of my work alongside direct links to my social profiles. Get to know me better in a single glance!",
        imgSrc: "https://drive.google.com/uc?export=view&id=1IyigL_VQvSPh3wIdkW-bVDGj794PMImm",
        link: "https://cardinfo-himanshijainn.vercel.app/"
    },
    {
        id: 15,
        name: "Weather app ",
        tags: ["html","css","js"],
        description:"ClimaView is a user-friendly weather app that displays current conditions at a glance. Get instant access to temperature, humidity, and forecasts in a clean, modern interface. Stay prepared with ClimaView, your go-to weather companion.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1CwHWYAK8dq7TnSDT8I73vVFIrwMxuBEV",
        link: "https://weatherapp-himanshijainn.vercel.app/"
    },
    {
        id: 16,
        name: "Hangman game ",
        tags: ["html","css","js"],
        description:"Experience the classic word-guessing challenge with Hangman! Unveil the hidden word by guessing its letters before the drawing of the hangman is completed. Test your vocabulary and wit in this interactive game.",
        imgSrc: "https://drive.google.com/uc?export=view&id=1TB0CxTX3wHMfMPtdKMmHlKabx3rdJ77l",
        link: "https://hangmangame-himanshijainn.vercel.app/"
    }
] 